export const removeIn = (array: string[], item: string | string[]) => {
  const items = Array.isArray(item) ? item : [item];
  return array.filter((itemInArray) => !items.includes(itemInArray));
};
